import { CzechSuklRsAtcGroupsParams, useCzechSuklRsAtcGroups } from '~/libs/infrastructure/api/availability';

// Thin wrapper over the shared react-query hook so pages/consumers share one data source.
export function useAvailabilityData(params: CzechSuklRsAtcGroupsParams) {
	const { data, isFetching, isError } = useCzechSuklRsAtcGroups(params, {
		query: { keepPreviousData: true },
	});
	return { data, isFetching, isError };
}
